export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50].map((value) => ({
  label: String(value),
  value: String(value),
}));
